import { ParamMap, Params } from '@angular/router';
import { DateRange } from '../types/date-range.type';
import { ExtendedDateRange } from '../types/extended-date-range.type';

export class ParamMapHelper {
  static parseInterval(paramMap: ParamMap): DateRange {
    const from = ExtendedDateRange.parseQueryParam(paramMap.get('from'));
    const to = ExtendedDateRange.parseQueryParam(paramMap.get('to'));

    if (!from || !to) {
      return null;
    }

    const range = new DateRange(from, to);
    if (range.isValid() && range.start <= range.end) {
      return range;
    } else {
      throw new Error('Invalid date range');
    }
  }

  static parseDate(paramMap: ParamMap): Date {
    const date = paramMap.get('for');
    return date ? ExtendedDateRange.parseQueryParam(date) : null;
  }

  static parseValue<T>(paramMap: ParamMap, paramName: string, fallbackObject?: any): T {
    return paramMap.get(paramName) as T ?? fallbackObject?.[paramName] as T;
  }

  static parseArray<T>(paramMap: ParamMap, paramName: string, fallbackObject?: any): T[] {
    const queryParam = paramMap.get(paramName);
    return (queryParam?.length > 0 ? queryParam?.split(',') as T[] : null) ?? fallbackObject?.[paramName] as T[];
  }

  static containsIntervalParams(paramMap: ParamMap): boolean {
    return paramMap.has('from') && paramMap.has('to');
  }

  static convertToParams(paramMap: ParamMap): Params {
    const params: Params = {};
    paramMap.keys.forEach(key => (params[key] = paramMap.get(key)));
    return params;
  }

  static createIntervalParams(range: DateRange): Params {
    if (range == null) {
      return null;
    }
    return {
      from: ExtendedDateRange.formatQueryParam(range.start),
      to: ExtendedDateRange.formatQueryParam(range.end),
    };
  }

  static createDateParams(date: Date): Params {
    if (date == null) {
      return null;
    }

    return {
      for: ExtendedDateRange.formatQueryParam(date),
    };
  }
}
